import staticConfig from 'src/config'

export type ExplorerLinkType = 'tx' | 'address' | 'token'

export interface ExplorerUrlOptions {
  type: ExplorerLinkType
  hash: string | undefined
  chainId: number | undefined
}

const { supportedChains } = staticConfig

export const getExplorerUrl = ({ type, hash, chainId }: ExplorerUrlOptions) => {
  if (!hash) return ''

  const chain = supportedChains.find(chain => chain.id === chainId)
  const explorerLinkPrefix = chain?.blockExplorers?.[0].url

  return `${explorerLinkPrefix}/${type}/${hash}`
}
